export default __webpack_public_path__ + "static/media/clickup-icon.5a8e9bf2.svg";